/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import Item from '../item';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store';
import router from '@/router';

/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.DragImagesToMatch.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.bg = null;
  this.items = [];
  this.shadows = [];
  this.instructions = null;
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.DragImagesToMatch.Scenes.Main.prototype.constructor = EDC.Games.DragImagesToMatch.Scenes.Main;
/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

EDC.Games.DragImagesToMatch.Scenes.Main.prototype.createTemplateUI = function () {
  this.bg = this.returnBaseBackground();

  const titleFont = {
    font: `${this.gameConfig.titleSize} ${this.gameConfig.font}`,
  };
  const title = this.add.text(
    this.game.config.width / 2,
    1020,
    this.gameConfig.titleTxt,
    titleFont,
  ).setOrigin(0.5);
  const instructionsFont = {
    font: `${this.gameConfig.instructionsSize} ${this.gameConfig.font}`,
  };
  this.instructions = this.make
    .text({
      x: this.game.config.width / 2,
      y: 100,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0.5, y: 0.5 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: `${this.gameConfig.instructionsMaxWidth}` },
        lineSpacing: 15,
      },
    })
    .setDepth(1);
};

/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main.prototype.getRandomValueFromArray = function (targetArray) {
  const rndIdx = Math.floor(Math.random() * targetArray.length);
  const res = targetArray.splice(rndIdx, 1);
  return res[0];
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main.prototype.loadIteration = function () {
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.instructions.setDepth(0);
    this.showSummary();
  } else {
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].destroy();
      this.shadows[i].destroy();
    }
    this.items = [];
    this.shadows = [];

    const removed = [];
    const typeIndex = this.getTypeOfAssets();
    const itemsData = this.gameConfig.assets[typeIndex].items.map(elem => elem);
    this.bg.setTexture(this.gameConfig.assets[typeIndex].background);
    this.bg.displayWidth = this.game.config.width;
    this.bg.displayHeight = this.game.config.height;
    this.createItems(itemsData, removed, this.items, false);
    this.createItems(removed, null, this.shadows, true);
    this.appearIteration();
  }
};

EDC.Games.DragImagesToMatch.Scenes.Main.prototype.getTypeOfAssets = function () {
  let number;
  const { type } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < this.gameConfig.assets.length; i++) {
    if (this.gameConfig.assets[i].type === type) {
      number = i;
    }
  }
  return number;
};

EDC.Games.DragImagesToMatch.Scenes.Main.prototype.disappearIteration = function () {
  const distance = this.game.scale.height / 2;
  const targets = [];
  for (let i = 0; i < this.items.length; i++) {
    targets.push(this.items[i].getContainer());
    targets.push(this.shadows[i].getContainer());
  }
  this.tweens.add({
    targets,
    y: { value: `+=${distance}`, duration: 600, ease: 'Back.easeIn' },
    onComplete: () => {
      this.iteration = this.iteration + 1;
      this.loadIteration();
    },
  });
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main.prototype.createItems = function (dataArray, targetArray, objArray, isShadow) {
  const { itemsPerIteration } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const slotWidth = this.game.scale.width / itemsPerIteration;
  const startX = isShadow ? -this.game.scale.width : this.game.scale.width;
  for (let i = 0; i < itemsPerIteration; i++) {
    const item = this.getRandomValueFromArray(dataArray);
    if (targetArray) targetArray.push(item);
    const itemObj = new Item(this, item.id, isShadow).create();
    const itemWidth = itemObj.getWidth();
    itemObj.setPosition(startX + slotWidth * i + (slotWidth - itemWidth) / 2 + itemWidth / 2, isShadow ? 720 : 360);
    objArray.push(itemObj);
  }
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main.prototype.checkIterationDone = function () {
  let isDone = true;
  for (let i = 0; i < this.items.length; i++) {
    if (!this.items[i].isLocked) {
      isDone = false;
      break;
    }
  }
  if (isDone) {
    this.disappearIteration();
  }
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main.prototype.appearIteration = function () {
  const startX = this.game.scale.width;
  const targetShadows = [];
  for (let i = 0; i < this.items.length; i++) {
    targetShadows.push(this.shadows[i].getContainer());
  }
  for (let i = 0; i < this.items.length; i++) {
    this.tweens.add({
      targets: this.items[i].getContainer(),
      x: { value: `-=${startX}` },
      duration: 1000,
      ease: 'Back.easeOut',
      onComplete: function (item) {
        const container = item.getContainer();
        item.setPosition(container.x, container.y);
      }.bind(this, this.items[i]),
    });
  }
  this.tweens.add({
    targets: targetShadows,
    x: { value: `+=${startX}`, duration: 1000, ease: 'Back.easeOut' },
  });
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main.prototype.incrementAnswersCounter = function (isWrong = true) {
  if (isWrong) {
    this.playWrong();
  } else {
    this.playCorrect();
  }
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Scenes.Main.prototype.getShadowUnderPointer = function (container) {
  for (let i = 0; i < this.shadows.length; i++) {
    const res = this.shadows[i].isContainPoint(container);
    if (res) return this.shadows[i];
  }
  return null;
};

export default EDC.Games.DragImagesToMatch.Scenes.Main;
